import { render, staticRenderFns } from "./KegiatanList.vue?vue&type=template&id=07f6b6ea"
import script from "./KegiatanList.vue?vue&type=script&lang=js"
export * from "./KegiatanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports